import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const formRef = useRef(null);
  const iframeRef = useRef(null);
  const auth = getAuth();
  const [user] = useAuthState(auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Submit the form to FormSubmit for email (using the iframe)
    formRef.current.submit();
    
    // Show success message and reset form after a delay
    setTimeout(() => {
      setShowSuccess(true);
      setIsSubmitting(false);
      formRef.current.reset();
    }, 2000);
  };

  const renderContent = () => {
    if (showSuccess) {
      return (
        <div className="success-container">
          <h2>Thank you for your message!</h2>
          <p>We've received your submission and will get back to you shortly.</p>
        </div>
      );
    }

    return (
      <>
        <div className="contact-info">
          <p>
            If you do have a question, our <Link to="/faq">FAQ page</Link> might have the answer.
          </p>
          <p className="divider">- OR -</p>
          <p>
            If you're requesting a feature please use{' '}
            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSfl9w-g49qcl2NM9QKvg0BsZeflq_DlaZd9YsNcVB0loe3Nzg/viewform" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              this form
            </a>.
          </p>
          <p className="form-intro">If neither of those have what you need, fill out the form below:</p>
        </div>

        {/* Hidden iframe for form submission */}
        <iframe 
          name="hidden-iframe" 
          id="hidden-iframe" 
          ref={iframeRef}
          style={{ display: 'none' }}
          title="Hidden frame for form submission"
        ></iframe>

        <form 
          ref={formRef}
          action="https://formsubmit.co/kyle@odikai.bet"
          method="POST"
          target="hidden-iframe"
          onSubmit={handleSubmit}
          className="contact-form"
        >
          {/* FormSubmit Configuration */}
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="table" />
          <input type="hidden" name="_subject" value="New Contact Form Submission" />

          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your name..."
              required
              maxLength={100}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Your email..."
              required
              maxLength={100}
              disabled={isSubmitting}
              defaultValue={user?.email || ''}
              readOnly
            />
          </div>

          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your message..."
              required
              maxLength={1000}
              rows={6}
              disabled={isSubmitting}
            />
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Submit Message'}
          </button>
        </form>
      </>
    );
  };

  return (
    <>
      <div className="page-container">
        <header className="page-header">
          <div className="header-content">
            <h1>Contact Us</h1>
            <p className="header-subtitle">Questions? Feedback? Find a bug? You can reach us here.</p>
          </div>
        </header>

        <div className="contact-container">
          {renderContent()}
        </div>
      </div>
    </>
  );
} 